// Feature flags defined
// Result is only used for mockValues

interface IDYFF_FLAGS {
  featureId: string;
  result: boolean;
}

export const DYFF_FLAGS: IDYFF_FLAGS[] = [
  {
    featureId: 'BERNIE_TEST',
    result: true,
  },
  {
    featureId: 'EMAIL_NOTIFICATIONS',
    result: true,
  },
  {
    featureId: 'TAX_PROFILE_STEP',
    result: true,
  },
  {
    featureId: 'GA_ACCOUNT_STRUCTURE_IMAGE',
    result: true,
  },
  {
    featureId: 'GA_PAYMENT_STRUCTURE_IMAGE',
    result: true,
  },
  {
    featureId: 'SHARED_MULTIPLE_PAYMENT_PROFILES',
    result: true,
  },
  {
    featureId: 'SHOW_PARTNER_ACCOUNT_NAME',
    result: true,
  },
  {
    featureId: 'SHOW_NEW_BRANDING',
    result: true,
  },
  {
    featureId: 'CREDIT_LIMIT_CARD',
    result: true,
  },
  {
    featureId: 'SHARED_BASE_AD',
    result: true,
  },
  {
    featureId: 'LSL_CREATIVE_REJECTION_REASON',
    result: true,
  },
  {
    featureId: 'EDITABLE_START_DATE',
    result: true,
  },
  {
    featureId: 'SHOW_TOGGLE_OFF_DIALOG',
    result: false,
  },
  {
    featureId: 'CHANGE_HISTORY_SEPARATION',
    result: true,
  },
  {
    featureId: 'ONBOARDING_CURRENCY_STEP',
    result: true,
  },
  {
    featureId: 'COMPETITIVE_INSIGHTS',
    result: true,
  },
  {
    featureId: 'GRAPHQL_RUM',
    result: true,
  },
  {
    featureId: 'GRAPHQL_PERFORMANCE_STATS',
    result: true,
  },
  {
    featureId: 'SHOW_DUET_SURVEY',
    result: true,
  },
  {
    featureId: 'PAYMENT_PROFILE_MIGRATION_POST_ONBOARDING',
    result: false,
  },
  {
    featureId: 'PAYMENT_PROFILE_MIGRATION_ONBOARDING',
    result: false,
  },
  {
    featureId: 'SALESFORCE_UPDATE',
    result: false,
  },
  {
    featureId: 'PARTNER_OVERVIEW',
    result: true,
  },
  {
    featureId: 'SHARED_TARGET_ROAS_ENABLED',
    result: true,
  },
  {
    featureId: 'PAYMENT_PROFILE_SWITCH',
    result: true,
  },
  {
    featureId: 'PAYMENT_METHOD_CREDIT_CARD',
    result: true,
  },
  {
    featureId: 'SHARED_BID_STRENGTH_ENABLED',
    result: true,
  },
  {
    featureId: 'ONBOARDING_HELP_AND_SUPPORT',
    result: true,
  },
  {
    featureId: 'SHARED_ENABLE_BID_MODIFIER',
    result: true,
  },
  {
    featureId: 'SHARED_VRBO_ADS',
    result: true,
  },
  { featureId: 'PAYMENT_PROFILE_DETAIL', result: false },
  { featureId: 'ENABLE_PAYMENT_PROFILE_LIST', result: false },
  { featureId: 'SUSPENDED_PROPERTY_TYPEAHEAD_OPTION', result: true },
  {
    featureId: 'PARTNER_BILLING_WEB_CLIENT_SWITCH',
    result: true,
  },
  {
    featureId: 'CAMPAIGN_WIZARD_READ_ONLY_ENABLED',
    result: true,
  },
];
